import React, { useState, useEffect, createContext } from "react";

import { DataHelper } from "../../Common/Helpers/data-helper.js";

export const SsoContext = createContext();

function ssoContextProvider(props) {
    const [ssoSettings, setSsoSettings] = useState(null);

    useEffect(loadSsoSettings, []);

    function loadSsoSettings() {
        DataHelper.getSsoSettings(function (settings) {
            setSsoSettings(settings);
        });
    }

    return (
        <SsoContext.Provider value={ssoSettings}>
            {props.children}
        </SsoContext.Provider>
    );
}

export default ssoContextProvider;